import React from "react";
import "./view-crm-price-details.scss";
import { Box, Button, Tooltip } from "@mui/material";
import icons from "../../../../../assets/icons/icons";

interface ViewCRMPriceDetailsProps {
  setIsEditPrice?: any;
  from?: string;
  plans?: any;
  titile?: any;
}
const ViewCRMPriceDetails: React.FC<ViewCRMPriceDetailsProps> = ({
  setIsEditPrice,
  from,
  plans,
  titile,
}) => {
  const disableEditButton = ["No Cost", "Trial"];
  return (
    <Box className="view-price-details-wrapper">
      <Box className="header-wrapper">
        <p className="price-header">Pricing</p>

        {from !== "create" && !disableEditButton?.includes(titile) ? (
          <Button
            variant="outlined"
            className="price-edit-button"
            onClick={() => setIsEditPrice(true)}
          >
            Edit Pricing
          </Button>
        ) : (
          <Tooltip
            title={
              "Price is fixed at $0 for Trial and No Cost plans and cannot be edited"
            }
            arrow
            enterTouchDelay={0}
            sx={{ fontSize: "16px", fontWeight: 400, fontFamily: "Roboto" }}
          >
            <img src={icons.PriceInfo} alt="Price information icon" />
          </Tooltip>
        )}
      </Box>
      <Box className="price-body">
        <Box className="price-item">
          <p className="price-label">Monthly</p>
          <p className="price-value">
            $ {from === "create" ? 0 : plans?.monthlyPrice || 0}
          </p>
        </Box>
        <Box className="price-item">
          <p className="price-label">Yearly</p>
          <p className="price-value">
            $ {from === "create" ? 0 : plans?.annualPrice || 0}
          </p>
        </Box>
      </Box>
    </Box>
  );
};

export default ViewCRMPriceDetails;
